import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { removeBodyScroll, scroll2Id, getDateTime } from '../../helper';
import { saveResume as saveResumeAction, PREVIEW_RESUME } from '../../services/actions/actions';
import { usePopup } from '../../context/PopupContext';
import { HEADING_LINK, WORKHISTORY_LINK, EDUCATION_LINK, SKILLS_LINK, ADDITIONAL_SECTIONS_LINK, FINAL_RESUME, POPUP_TYPES, COOKIE_DOMAIN, REARRANGE_LINK, QUICK_EDITOR, PAID_SERVICES, MEMBERSHIP, SUMMARY_LINK, COVERLETTER_EXPERIENCE, APP_DOMAIN } from '../../constants/constants';
import { useHistory, useLocation } from "react-router-dom";
import downloadResume from '../../downloadResume';
import WpAPI from "../../WpApi";
import SignUpPopup from '../user/SignUpPopup';  
import LogoImage from '../../assets/images/small-rb-logo.svg';
import Cookie from 'js-cookie';
import { userCompletesSectionsDownloadsPrintsOrShares as userCompletesSectionsDownloadsPrintsOrSharesAction } from '../../services/actions/actions';
import PageLoader from './PageLoader';
import { useUser } from '../../context/UserContext';
import { useResume } from '../../context/ResumeContext';

const LeftPanel = (props) => {
    const dispatch = useDispatch();
    const popupbox = usePopup();
    const history = useHistory();
    const location = useLocation();

    const [togglePanel, setTogglePanel] = useState(window?.innerWidth > 770 ? '1' : '0');
    const [showEditSection, setShowEditSection] = useState(true);
    const [accordState, setAccordState] = useState({ active: {}, unlocked: [], });
    const [resumes, setResumes] = useState('');
    const [resumeLink, setResumeLink] = useState(false);
    const [saved, setSaved] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [filledClass, setFilledClass] = useState('');
    const [showLoginPopUp, setShowLoginPopUp] = useState(false);
    const [loader, setLoader] = useState({download: false, save: false, share: false});
    const [showUpgradeBanner, setShowUpgradeBanner] = useState(false);

    const {
        checkMembership,
        plan,
        user
    } = useUser();

    //get props from context -- ResumeContext
    const contextProps = useResume();

    const mounted = useRef(false);

    useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);

    useEffect(() => {
        popupbox.configurePopup(POPUP_TYPES);
        const lps = Cookie.get('left_panel_state', {domain: COOKIE_DOMAIN, path: "/"})
        if(window.innerWidth > 770 && lps?.length && lps.length)  setTogglePanel(lps)
        else if(window.innerWidth > 770 && !lps?.length) setTogglePanel('1')
    }, []);

    const tabClicked = (t) => {
        //if (accordState.unlocked.includes(t)) {
        //Only enabled tabs
        //setAccordState({ ...accordState, active: { ...accordState.active, [t]: !accordState.active[t] } })
        scroll2Id(`${t}_tab`, 500);
        //}
    }
    const togglePanelAction = () =>{
        const toggle = togglePanel=='1' ? '0' : '1'
        window.innerWidth > 770 && Cookie.set('left_panel_state', toggle, { domain: COOKIE_DOMAIN, path: '/' });
        setTogglePanel(toggle)
    }
    const saveResume = () => {
        if(typeof saved != 'undefined') setSaved('Saved!');
        dispatch(saveResumeAction(
            { modified_date: getDateTime() },
            PREVIEW_RESUME,
            true
        ));
    }

    if(saved){
        setTimeout(() => { 
            setSaved(false) 
        }, 2000);
    }

    const downloadResumeHandler = (downloadFormat) => {
        downloadResume(contextProps, user, () => { 
            popupbox.close('download');
            popupbox.show('askfor_trustpilot_review', null, () => {
                window.open( `https://www.trustpilot.com/review/resume.org`, '_blank');
              });
        }, downloadFormat, {type: 'resume', name: 'Resume' });
    }

    const goToSection = (section, link) => {
        //if(contextProps.resume.active_editor == 'traditional') setTogglePanel(true);
        // if(link == REARRANGE_LINK ) history.push(link)
        // else 
        if(section.length) tabClicked(section)
        else history.push(link)
    }

    const userCompletesSectionsDownloadsPrintsOrShares = () => {
        dispatch(userCompletesSectionsDownloadsPrintsOrSharesAction(contextProps.resume, 'currentResume')).then(res => {
            if(res.completed){
                const ec = (PAID_SERVICES && plan == 'pro' ? 'app_editor_finalizations' : 'app_editor_finalizations_free');
                const el = (
                    PAID_SERVICES && plan == 'pro' 
                    ? 'User completes sections: Downloads, Prints or Shares' 
                    : 'Free user completes sections: tries to download, print, share'
                );
                ga4Track(ec, 'RB App', el)
            }
        })
    }

    const download = () => {
        saveResume();
        localStorage.setItem('clickAction', 'download');
        if(WpAPI.isLoggedIn()){
            // if(PAID_SERVICES){
            //     plan == 'pro' 
            //     ? popupbox.show('download', null, () => downloadResumeHandler()) 
            //     : history.push(MEMBERSHIP);
            // }else{
            //     popupbox.show('download', null, () => downloadResumeHandler()) 
            // }
            /**
             * #775: Any logged in users can download the resume in the text format. 
             * Action: Removed the above code snippet having PAID_SERVICES and plan check.
             * Date: 2023-07-21
             */
            popupbox.show('download', null, (params) => {
                downloadResumeHandler(params.downloadFormat);
                userCompletesSectionsDownloadsPrintsOrShares();
                ga4Track('app_sidebar_download', 'RB App', 'Download');
            }, {plan: plan, loader: loader, entity: {type: 'resume', name: 'Resume' }});
        }else{
            setShowLoginPopUp(true);
            ga4Track('app_sidebar_download_button_popup', 'RB App', 'Login/Signup Popup');
        }
    }

    const save = () => {
        saveResume();
        if(WpAPI.isLoggedIn()){
            {/** START: changes for #858 */}
            // if(PAID_SERVICES){
            //     plan == 'pro' ? saveResume() : history.push(MEMBERSHIP);
            // }else{
            //     saveResume();
            // }
            {/** END */}
            userCompletesSectionsDownloadsPrintsOrShares();
            gaTrack('RB App', `Sidebar`, `Save`);
            ga4Track('app_sidebar_save', 'RB App', 'Save');
        }else{
            //saveResume(); // changes for #858
            setShowLoginPopUp(true);
            gaTrack('RB App', `Sidebar`, `Login/Signup Popup`);
            ga4Track('app_sidebar_save_button_popup', 'RB App', 'Login/Signup Popup');
        }
    }

    const share = () => {
        //setLoader({...loader, share: false});
        localStorage.setItem('clickAction', 'share');
        if(WpAPI.isLoggedIn()){
            if(PAID_SERVICES){
                if(plan == 'pro'){
                    popupbox.show('share', null, () => {
                        //do something..
                    }, {resume: {...contextProps.resume, id: contextProps.currentResume}, user: contextProps.user, type: 'currentResume', entity:{type: 'resume', name: 'Resume' }})
                }else{
                    history.push(MEMBERSHIP);
                }
            }else{
                popupbox.show('share', null, () => {
                    //do something..
                }, {resume: {...contextProps.resume, id: contextProps.currentResume}, user: contextProps.user, type: 'currentResume', entity:{type: 'resume', name: 'Resume' }})
            }
            gaTrack('RB App', 'Sidebar', 'Share')
            ga4Track('app_sidebar_share', 'RB App', 'Share');
            userCompletesSectionsDownloadsPrintsOrShares();
        }else{
            setShowLoginPopUp(true);
            gaTrack('RB App', `Sidebar`, `Login/Signup Popup`);
            ga4Track('app_sidebar_share_button_popup', 'RB App', 'Login/Signup Popup');
        }
    }

    const upgradeGAEvents = () => {
        if(WpAPI.isLoggedIn()){
            ga4Track('app_sidebar_upgrade_now', 'RB App', 'Sidebar: Upgrade Now');
            history.push(MEMBERSHIP);
        }else{
            setShowLoginPopUp(true);
        }
    }

    const UpgradeHtml = () => {
        if(!WpAPI.isLoggedIn())
            return null;
        return (
            PAID_SERVICES && (plan === null 
            ? <PageLoader /> 
            : (plan !== 'pro' && <div className="right-upgrade-panel">
                <div className="small-logo">
                    <LogoImage></LogoImage>
                </div>
                <h3>Upgrade your account and get these premium services:</h3>
                <ul>
                    <li>Unlimited resumes</li>
                    {/* MS Word and  */}
                    <li>Unlimited downloads in PDF</li>
                    <li>Premium templates</li>
                    <li>Custom fonts and colors</li>
                </ul>
                <div className="upgrade-btn" onClick={() => upgradeGAEvents()}><a>Upgrade Now</a></div>
            </div>))
        );
    }

    const checkMembershipAction = (callback = false, params = false) => {
        if(typeof callback == 'function' && mounted.current) 
            setLoader({...loader, [callback.name]: true});
        checkMembership(() => {
            if(typeof callback == 'function'){
                callback(params);
                if(mounted.current) setLoader({...loader, [callback.name]: false});
            }
            if(plan != 'promo' && mounted.current) setShowUpgradeBanner(true);
        });
    }

    return (<><div className={`app-left-panel${togglePanel === '1' ? ' open' : ''}`}>
        <div className={`app-left-panel-inner${togglePanel === '1' ? ' open-panel' : ''}`}>
            <div className={`arrow-btn${togglePanel === '1' ? ' change-arrow-position' : ''}`} onClick={() => togglePanelAction()}>
                <i 
                    className={`${(togglePanel === '1' ? "icon-double-arrow-left" :  "icon-double-arrow-right")} hide-in-desktop`}
                    onClick={(e) => {
                        if(togglePanel === '1') ga4Track('app_sidebar_close_sidebar', 'RB App', 'Close Sidebar')
                        else ga4Track('app_sidebar_open_sidebar', 'RB App', 'Open Sidebar')
                    }}></i>
                <i 
                    className={`${(togglePanel === '1' ? "icon-left-arrow" : "icon-right-arrow")} hide-in-mobile`}
                    onClick={(e) => {
                        if(togglePanel === '1') ga4Track('app_sidebar_close_sidebar', 'RB App', 'Close Sidebar')
                        else ga4Track('app_sidebar_open_sidebar', 'RB App', 'Open Sidebar')
                    }}></i>
            </div>
            <div className="left-panel">
                <ul className="item-list">
                    <li><div className="item edit-section"><i className="icon-edit-copy"></i><span>Edit Section
                        <i className={showEditSection ? 'icon-right-arrow':'icon-left-arrow'} onClick={()=>setShowEditSection(!showEditSection)} data-acsb-navigable="true"></i></span></div>
                    
                        {showEditSection && <ul className="sub-item-list">
                            <li onClick={(e) => {
                                goToSection('heading', HEADING_LINK);
                                ga4Track('app_sidebar_personal', 'RB App', 'Personal');
                            }}><div className="sub-item color-1"><i className="icon-user"></i><span className={(contextProps.resume.enabled_tabs.includes('heading') ? "filled" : "")}>Contact Information {(contextProps.resume.enabled_tabs.includes('heading') ? <i className="icon-tick-with-circle"></i> : '')}</span></div></li>
                            <li onClick={(e) => {
                                goToSection('work_history', WORKHISTORY_LINK);
                                ga4Track('app_sidebar_professional', 'RB App', 'Professional');
                            }}><div className="sub-item color-2"><i className="icon-briefcase"></i><span className={(contextProps.resume.enabled_tabs.includes('work_history') ? "filled" : "")}> Add Your Professional Experience {(contextProps.resume.enabled_tabs.includes('work_history') ? <i className="icon-tick-with-circle"></i> : '')}</span></div></li>
                            <li onClick={(e) => {
                                goToSection('education', EDUCATION_LINK);
                                ga4Track('app_sidebar_educational', 'RB App', 'Educational');
                            }}><div className="sub-item color-3"><i className="icon-graduation-cap"></i><span className={(contextProps.resume.enabled_tabs.includes('education') ? "filled" : "")}>Add Your Education
                            {(contextProps.resume.enabled_tabs.includes('education') ? <i className="icon-tick-with-circle"></i> : '')}</span></div></li>
                            <li onClick={(e) => {
                                goToSection('skills', SKILLS_LINK);
                                ga4Track('app_sidebar_key_skills', 'RB App', 'Key Skills');
                            }}><div className="sub-item color-4"><i className="icon-trophy"></i><span className={(contextProps.resume.enabled_tabs.includes('skills') ? "filled" : "")}>List Your Key Skills
                            {(contextProps.resume.enabled_tabs.includes('skills') ? <i className="icon-tick-with-circle"></i> : '')}</span></div></li>
                            <li onClick={(e) => {
                                goToSection('additional_sections', ADDITIONAL_SECTIONS_LINK);
                                ga4Track('app_sidebar_custom', 'RB App', 'Custom');
                            }}><div className="sub-item color-5"><i className="icon-pencil"></i><span className={(contextProps.resume.enabled_tabs.includes('additional_sections') ? "filled" : "")}>Add More Sections{(contextProps.resume.enabled_tabs.includes('additional_sections') ? <i className="icon-tick-with-circle"></i> : '')}</span></div></li>
                            <li onClick={(e) => {
                                goToSection('summary', SUMMARY_LINK);
                                ga4Track('app_sidebar_professional', 'RB App', 'Summary');
                            }}><div className="sub-item color-1"><i className="icon-user"></i><span className={(contextProps.resume.enabled_tabs.includes('summary') ? "filled" : "")}>Add Your Summary {(contextProps.resume.enabled_tabs.includes('summary') ? <i className="icon-tick-with-circle"></i> : '')}</span></div></li>
                        </ul>}
                    </li>
                    <li onClick={() => {
                        saveResume();
                        localStorage.setItem('referrer', window.location.pathname);
                        history.push({ 
                            pathname: FINAL_RESUME,
                            state: {
                                openPanel: true,
                                referrer: `${window.location.pathname}`
                            }
                        })
                        ga4Track('app_sidebar_template', 'RB App', 'Template');
                    }}>
                        <div className="item"><i className="icon-palette"></i><span>Template</span></div></li>
                    <li onClick={() => {
                        goToSection('', REARRANGE_LINK);
                        ga4Track('app_sidebar_rearrange', 'RB App', 'Rearrange');
                    }}><div className="item"><i className="icon-grid"></i><span>Rearrange</span></div></li>
                    <li onClick={() => checkMembershipAction(download)}><div className="item"><i className="icon-download-copy"></i><span>{loader.download ? 'Loading...' : 'Download'}</span></div></li>
                    <li onClick={() => checkMembershipAction(save)}>
                        <div className="item">
                            {saved ? <><i className="icon-tick-light"></i><span>Saved!</span></> : <><i className="icon-save"></i><span>{loader.save ? 'Loading...' : 'Save'}</span></>}
                        </div>
                    </li>
                    <li onClick={() => checkMembershipAction(share)}><div className="item"><i className="icon-share-from-square"></i><span>{loader.share ? 'Loading...' : 'Share'}</span></div></li>
                </ul>
            </div>
            { showUpgradeBanner && <UpgradeHtml /> }
        </div>
    </div>
    {showLoginPopUp ? <SignUpPopup setShowLoginPopUp={(c) => { setShowLoginPopUp(c) }} /> : ''}
    </>);
}

export default LeftPanel;